module.exports = __webpack_public_path__ + "static/media/5DPO18.fdef5df5.jpg";